<template>
  <div>
    <div class="promotionTitle notranslate">{{typeToLocale(this.$route.params.type)}}</div>
    <PhotoGrid
    :lang="lang"
    :locale="locale"
    :list="list"/>
  </div>
</template>

<script>
import PhotoGrid from '@/components/LocalInfo/promotion/PhotoGrid.vue'

export default {
  name: 'LocalList',
  props: [
    'locale',
    'lang',
    'list'
  ],
  components: {
    PhotoGrid
  },
  methods: {
    typeToLocale (type) {
      type = `localinfo_${type}`
      return this.locale[type]
    }
  },
  created () {
    this.$store.commit('loading', true)
  },
  mounted () {
    this.$store.commit('loading', false)
    this.$store.commit('translateReady', true)
    if (document.querySelector('.localItem.active') !== null) {
      setTimeout(() => {
        const top = document.querySelector('.localItem.active').offsetTop - 30
        window.scrollTo(0, top)
      })
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
    @media (min-width: 468px) {
      @media (min-width: 1440px) {
        .promotionTitle{
          padding: 20px calc(50% - 520px) 10px calc(50% - 520px) !important;
        }
      }
    }
  }
.promotionTitle{
    margin-left: 10px;
    padding: 0px calc(50% - 320px) 0px calc(50% - 320px);
    font-size: 22px;
    font-weight: 700;
  }
.list {
  padding: 15px;
}
.noData {
  padding: 75px 30px 200px;
  text-align: center;
  font-size: 1.2em;
  &:before {
    content: "";
    display: block;
    height: 128px;
    margin-bottom: 15px;
    background: url('~@/assets/img/localinfo_nodata.png') 50% 50% / contain no-repeat;
  }
}
</style>
